import type { BlastSportSummary, Gender, SportWithTeams } from '../types';

export const filterSportsByQuery = (
  sports: SportWithTeams[],
  query: string,
): SportWithTeams[] => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return sports;
  return sports.filter((s) => s.name.toLowerCase().includes(trimmed));
};

const ALL_GENDERS: Gender[] = ['BOYS', 'GIRLS', 'COED'];

export const getAvailableBlastSports = (
  blastSports: BlastSportSummary[],
  existingSports: SportWithTeams[],
): BlastSportSummary[] => {
  return blastSports.filter((bs) => {
    const takenGenders = new Set(
      existingSports
        .filter((s) => s.isActive && s.name.toLowerCase() === bs.name.toLowerCase())
        .map((s) => s.gender),
    );
    return ALL_GENDERS.some((g) => !takenGenders.has(g));
  });
};

export const getDisabledGenders = (
  existingSports: SportWithTeams[],
  selectedSportName: string,
): Set<Gender> => {
  const lowered = selectedSportName.trim().toLowerCase();
  return new Set(
    existingSports
      .filter((s) => s.isActive && s.name.toLowerCase() === lowered)
      .map((s) => s.gender),
  );
};
